var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",class:{'menu-open': _vm.$store.state.menuOpen},on:{"click":_vm.closeMenu}},[_c('side-menu'),_vm._v(" "),_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)]),_vm._v(" "),(!_vm.hideFooter)?_c('AppFooter'):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65c5c6ac","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./prompts/containers/Full.vue
// module id = null
// module chunks = 